<template>
    <div>
        <router-view />
    </div>
</template>

<script>
import config from "@/config";
import cookies from "js-cookie";
export default {
    methods: {
        async checkLocationAndRedirect() {
            try {
                // 과거 홈페이지에서 사용하던 URL로 진입한 경우인지 체크
                this.checkRedirectPastURL();

                // IP 기반 지역 감지 (ipapi.co 무료 API 사용)
                const response = await fetch("https://ipapi.co/json/");
                const data = await response.json();

                // country_code가 "KR"인 경우 한국
                const isKorea = data.country_code === "KR";

                // 리디렉션이 필요한지 확인
                if (this.checkNeedRedirect(isKorea)) {
                    if (isKorea) {
                        window.location.href = "https://kr.korot.com";
                    } else {
                        window.location.href = "https://us.korot.com";
                    }
                }
            } catch (error) {
                console.error("지역 감지 실패:", error);

                // API 호출 실패 시 타임존으로 백업 체크
                const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                const isKorea = timezone === "Asia/Seoul";

                // 리디렉션이 필요한지 확인
                if (this.checkNeedRedirect(isKorea)) {
                    if (isKorea) {
                        window.location.href = "https://kr.korot.com";
                    } else {
                        window.location.href = "https://us.korot.com";
                    }
                }
            }
        },
        // 과거 홈페이지에서 사용하던 URL로 진입한 경우
        checkRedirectPastURL() {
            // 현재 도메인 확인
            const currentDomain = window.location.href;

            if (currentDomain.includes("https://korot.com/kr") || currentDomain.includes("https://www.korot.com/kr")) {
                window.location.href = "https://korot.com";
            } else if (
                currentDomain.includes("https://korot.com/index") ||
                currentDomain.includes("https://www.korot.com/index")
            ) {
                window.location.href = "https://korot.com/support/demo-request";
            } else if (
                currentDomain.includes("https://korot.com/demo") ||
                currentDomain.includes("https://www.korot.com/demo")
            ) {
                window.location.href = "https://korot.com/support/demo-request";
            } else if (
                currentDomain.includes("https://korot.com/story") ||
                currentDomain.includes("https://www.korot.com/story")
            ) {
                window.location.href = "https://korot.com/about/our-story";
            } else if (
                currentDomain.includes("https://korot.com/p3accurate") ||
                currentDomain.includes("https://www.korot.com/p3accurate")
            ) {
                window.location.href = "https://korot.com/products/p3-accurate";
            } else if (
                !currentDomain.includes("https://korot.com/technology/") &&
                (currentDomain.includes("https://korot.com/technology") ||
                    currentDomain.includes("https://www.korot.com/technology"))
            ) {
                window.location.href = "https://korot.com/technology/innovation";
            } else if (
                currentDomain.includes("https://korot.com/recruit") ||
                currentDomain.includes("https://www.korot.com/recruit")
            ) {
                window.location.href = "https://korot.career.greetinghr.com/ko/intro";
            } else if (
                currentDomain.includes("https://korot.com/en") ||
                currentDomain.includes("https://www.korot.com/en")
            ) {
                window.location.href = "https://us.korot.com";
            } else if (
                currentDomain.includes("https://korot.com/en/about/story") ||
                currentDomain.includes("https://www.korot.com/en/about/story")
            ) {
                window.location.href = "https://us.korot.com/about/our-story";
            } else if (
                currentDomain.includes("https://korot.com/en/product") ||
                currentDomain.includes("https://www.korot.com/en/product")
            ) {
                window.location.href = "https://us.korot.com/products/p3-accurate";
            } else if (
                currentDomain.includes("https://korot.com/en/technology") ||
                currentDomain.includes("https://www.korot.com/en/technology")
            ) {
                window.location.href = "https://us.korot.com/technology/innovation";
            }
        },
        checkNeedRedirect(isKorea) {
            // 현재 도메인 확인
            const currentDomain = window.location.href;

            // 어드민인경우 리디렉션 필요 없음
            if (currentDomain.includes("admin") || currentDomain.includes("?isDirect=1")) {
                return false;
            } else {
                const koreaSites = [
                    "https://testkorothomepage-dmfqdjcycsgzc5ad.koreacentral-01.azurewebsites.net",
                    "http://localhost:8080",
                    "https://korot.com",
                    "https://www.korot.com",
                    "https://kr.korot.com",
                ];
                const usSites = ["https://us.korot.com"];

                if (isKorea) {
                    // 한국 사용자이면서 현재 도메인이 한국 사이트가 아닌 경우 리디렉션 필요
                    return !koreaSites.some((site) => currentDomain.includes(site));
                } else {
                    // 미국 사용자이면서 현재 도메인이 미국 사이트가 아닌 경우 리디렉션 필요
                    return !usSites.some((site) => currentDomain.includes(site));
                }
            }
        },
        gtag() {
            window.dataLayer.push(arguments);
        },
    },
    created() {
        // 지역 감지 및 리디렉션
        const currentDomain = window.location.href;
        if (!(currentDomain.includes("-slot") && currentDomain.includes(".azurewebsites.net")))
            this.checkLocationAndRedirect();

        // 추후 다국어 처리시 아래 코드 활용 일단 한글 강제 적용
        // this.$i18n.locale =
        //     languageCode === undefined || languageCode === null || languageCode === ''
        //         ? 'ko'
        //         : languageCode
        this.$i18n.locale = config.isUS ? "en" : "ko";

        const cookiePermision = cookies.get("SYSTEM_COOKIE_PERMISSION");
        // google Analytics 비활성화
        window.dataLayer = window.dataLayer || [];

        // 기능 쿠키 허용시 구글 애널리틱스 활성화 & 한국인 경우 쿠키 허용여부를 사용하지 않으므로 활성화
        if ((cookiePermision && cookiePermision.includes("FUNCTIONAL")) || !config.isUS) {
            this.gtag("consent", "update", {
                ad_storage: "granted",
                analytics_storage: "granted",
                ad_user_data: "granted",
                ad_personalization: "granted",
            });
        } else {
            this.gtag("consent", "update", {
                ad_storage: "denied",
                analytics_storage: "denied",
                ad_user_data: "denied",
                ad_personalization: "denied",
            });
        }

        window.gtag = this.gtag;
    },
    mounted() {
        console.log("");
    },
};
</script>

<style>
@import "./assets/css/normalization.css";
/* @import "@/assets/css/iconImage.css"; */

@import url("https://cdn.jsdelivr.net/gh/orioncactus/pretendard/dist/web/static/pretendard.css");
</style>
